// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    background-color: white;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    border-radius: 0.5rem;
    overflow: hidden;
}

.card-header {
    background-color: #f9fafb;
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #e5e7eb;
}

.card-title {
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 500;
    color: #111827;
}

.card-content {
    padding: 1rem 1.5rem;
}

.form-radio {
    height: 1rem;
    width: 1rem;
    color: #38EF7D;
    border-color: #d1d5db;
}

    .form-radio:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(56, 239, 125, 0.2);
    }

.form-checkbox {
    height: 1rem;
    width: 1rem;
    color: #38EF7D;
    border-color: #d1d5db;
    border-radius: 0.25rem;
}

    .form-checkbox:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(56, 239, 125, 0.2);
    }

input[type="text"],
input[type="color"],
select {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

    input[type="text"]:focus,
    input[type="color"]:focus,
    select:focus {
        outline: none;
        ring: 2px;
        ring-color: #38EF7D;
        border-color: #38EF7D;
    }

button {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    font-weight: 500;
    border-radius: 0.375rem;
    transition: background-color 0.2s;
}

    button:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(56, 239, 125, 0.5);
    }

.bg-[#38EF7D] {
    background-color: #38EF7D;
}

    .bg-[#38EF7D]:hover {
        background-color: #2ECC71;
    }

.text-[#0F3443] {
    color: #0F3443;
}

.space-y-2 > * + * {
    margin-top: 0.5rem;
}

.space-y-4 > * + * {
    margin-top: 1rem;
}

.space-y-6 > * + * {
    margin-top: 1.5rem;
}

.flex {
    display: flex;
}

.items-center {
    align-items: center;
}

.justify-between {
    justify-content: space-between;
}

.gap-2 {
    gap: 0.5rem;
}

.h-2dot5 {
    height: 0.625rem;
}

.max-w-2xl {
    max-width: 42rem;
}

.mx-auto {
    margin-left: auto;
    margin-right: auto;
}

.p-6 {
    padding: 1.5rem;
}

.pt-4 {
    padding-top: 1rem;
}

.text-sm {
    font-size: 0.875rem;
}

.font-medium {
    font-weight: 500;
}

.text-gray-700 {
    color: #374151;
}

.bg-gray-100 {
    background-color: #f3f4f6;
}

.rounded-md {
    border-radius: 0.375rem;
}

.rounded-full {
    border-radius: 9999px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/app-wizard/app-wizard.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,iFAAiF;IACjF,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,qBAAqB;AACzB;;IAEI;QACI,aAAa;QACb,6CAA6C;IACjD;;AAEJ;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;IAEI;QACI,aAAa;QACb,6CAA6C;IACjD;;AAEJ;;;IAGI,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,2CAA2C;AAC/C;;IAEI;;;QAGI,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,qBAAqB;IACzB;;AAEJ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,iCAAiC;AACrC;;IAEI;QACI,aAAa;QACb,6CAA6C;IACjD;;AAEJ;IACI,yBAAyB;AAC7B;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".card {\n    background-color: white;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n    border-radius: 0.5rem;\n    overflow: hidden;\n}\n\n.card-header {\n    background-color: #f9fafb;\n    padding: 1rem 1.5rem;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.card-title {\n    font-size: 1.125rem;\n    line-height: 1.75rem;\n    font-weight: 500;\n    color: #111827;\n}\n\n.card-content {\n    padding: 1rem 1.5rem;\n}\n\n.form-radio {\n    height: 1rem;\n    width: 1rem;\n    color: #38EF7D;\n    border-color: #d1d5db;\n}\n\n    .form-radio:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px rgba(56, 239, 125, 0.2);\n    }\n\n.form-checkbox {\n    height: 1rem;\n    width: 1rem;\n    color: #38EF7D;\n    border-color: #d1d5db;\n    border-radius: 0.25rem;\n}\n\n    .form-checkbox:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px rgba(56, 239, 125, 0.2);\n    }\n\ninput[type=\"text\"],\ninput[type=\"color\"],\nselect {\n    width: 100%;\n    padding: 0.5rem 0.75rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.375rem;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n    input[type=\"text\"]:focus,\n    input[type=\"color\"]:focus,\n    select:focus {\n        outline: none;\n        ring: 2px;\n        ring-color: #38EF7D;\n        border-color: #38EF7D;\n    }\n\nbutton {\n    padding: 0.5rem 1rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    border-radius: 0.375rem;\n    transition: background-color 0.2s;\n}\n\n    button:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px rgba(56, 239, 125, 0.5);\n    }\n\n.bg-[#38EF7D] {\n    background-color: #38EF7D;\n}\n\n    .bg-[#38EF7D]:hover {\n        background-color: #2ECC71;\n    }\n\n.text-[#0F3443] {\n    color: #0F3443;\n}\n\n.space-y-2 > * + * {\n    margin-top: 0.5rem;\n}\n\n.space-y-4 > * + * {\n    margin-top: 1rem;\n}\n\n.space-y-6 > * + * {\n    margin-top: 1.5rem;\n}\n\n.flex {\n    display: flex;\n}\n\n.items-center {\n    align-items: center;\n}\n\n.justify-between {\n    justify-content: space-between;\n}\n\n.gap-2 {\n    gap: 0.5rem;\n}\n\n.h-2dot5 {\n    height: 0.625rem;\n}\n\n.max-w-2xl {\n    max-width: 42rem;\n}\n\n.mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.p-6 {\n    padding: 1.5rem;\n}\n\n.pt-4 {\n    padding-top: 1rem;\n}\n\n.text-sm {\n    font-size: 0.875rem;\n}\n\n.font-medium {\n    font-weight: 500;\n}\n\n.text-gray-700 {\n    color: #374151;\n}\n\n.bg-gray-100 {\n    background-color: #f3f4f6;\n}\n\n.rounded-md {\n    border-radius: 0.375rem;\n}\n\n.rounded-full {\n    border-radius: 9999px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
